import { useEffect, useState } from 'react';
import useTranslation from '../../../../hooks/useTranslations';
import ContentWrapper from '../../layouts/partials/ContentWrapper';
import ObjectTile from '../partials/tiles/ObjectTile';
import TileWrapper from '../partials/TileWrapper';
import ChipFilterMultipleFields from '../../../misc/tags/ChipFilterMultipleFields';
import { selectDoctypesByIds } from '../../../../redux/modules/data/doctypesSlice';

const FolderScreen = ({ activeTree }) => {
	const t = useTranslation();
	const [onlyDoctype, setOnlyDoctype] = useState([]);

	const activeFolder = activeTree?.folder3 ?? activeTree?.folder2;
	const activeObjects = activeTree.property ? activeFolder.realObjects.filter((object) => object.properties.includes(activeTree.property.id)) : activeFolder.realObjects;
	const targetEffect = activeTree.property ? activeTree.property.id : activeFolder.id;

	useEffect(() => {
		setOnlyDoctype([]);
	}, [targetEffect]);

	const onChipUpdate = (data) => {
		setOnlyDoctype(data.doctype);
	};

	if (activeFolder) {
		return (
			<>
				<ContentWrapper title={t(activeFolder.translationkey)} thumb={!activeFolder.realObjects ? activeFolder.image : ''}>
					<>
						<ChipFilterMultipleFields key={targetEffect} objectList={activeObjects} onSelectCallback={onChipUpdate} fieldMap={{ doctype: { fn: selectDoctypesByIds }}} />
						<TileWrapper containerClasses="pt-2">
							{activeObjects && activeObjects.map((object) => {
								if (!onlyDoctype.includes(object.doctype) && onlyDoctype.length !== 0) { return null; }

								return <ObjectTile key={object.id} object={object} setIsModalOpen={false} />;
							})}
						</TileWrapper>
					</>
				</ContentWrapper>
			</>
		);
	}

	return null;
};

export default FolderScreen;
